<template>
  <div class="chapter" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <ul>
        <div class="tit">第1章</div>
        <li>
          <div class="t fl">1-1 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-2 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-3 上课注意事项</div>
        </li>
      </ul>
      <ul>
        <div class="tit">第1章</div>
        <li>
          <div class="t fl">1-1 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-2 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-3 上课注意事项</div>
        </li>
      </ul>
      <ul>
        <div class="tit">第1章</div>
        <li>
          <div class="t fl">1-1 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-2 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-3 上课注意事项</div>
        </li>
      </ul>
      <ul>
        <div class="tit">第1章</div>
        <li>
          <div class="t fl">1-1 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-2 上课注意事项</div>
        </li>
        <li>
          <div class="t fl">1-3 上课注意事项</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        textarea: ''
      }
    },
    created () {

    }
  }
</script>

<style type="text/scss" lang="scss">
  .chapter {
    width: 360px;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    .content {
      ul {
        overflow: hidden;

        .tit {
          padding: 0 35px;
          margin: 30px auto 10px;
          font-size: 24px;
        }

        li {
          height: 60px;
          line-height: 60px;
          padding: 0 35px;

          .student {
            display: none;
            width: 80px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background-color: #ff8484;
            text-align: center;
            border-radius: 10px;
            margin: 10px 0 0 0;
            cursor: pointer;

            &:hover {
              background-color: #ffa8a8;
            }
          }

          &:hover {
            background-color: #fff8f8;
            color: #ff8484;

            .student {
              display: block;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/chapter/chapter.vue